import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import * as Types from './purchasePlus_graphql'

export const PureSupplierRelationshipsSelectionSupplierFragmentDoc = gql`
  fragment PureSupplierRelationshipsSelectionSupplier on Supplier {
    id
    name
  }
` as unknown as DocumentNode<Types.PureSupplierRelationshipsSelectionSupplierFragment, unknown>
